//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'Hero',
  props: {
    homepage: Boolean,
    backgroundUrl: {
      type: String,
      default: '',
    },
    overlay: {
      type: Boolean,
      default: false,
    },
    core: {
      type: Boolean,
      default: false,
    },
    virtualConference: {
      type: Boolean,
      default: false,
    },
    experiment: {
      type: Boolean,
      default: false,
    },
    landingPages: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      selectedProfession1: 'PT/PTA',
      selectedState2: 'Tennessee',
    };
  },
  computed: {
    hasTitle () {
      return !!this.$slots.title;
    },
    hasText () {
      return !!this.$slots.text;
    },
  },
};
